import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Form, Select, InputNumber } from "antd";
import CustomModal from "../../../components/Common/CustomModal";
import { PaymentMethodType } from "../../../types/paymentMethodTypes";
import { getLabelPaymentMethodByType } from "utils/stringUtils";
import PaymentMethodExtraFields from "../components/PaymentMethodExtraFields";

interface AddFeePaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  feeId: string;
  paymentMethods: PaymentMethodType[];
  amountNotPaid: number;
}

const AddFeePaymentModal: React.FC<AddFeePaymentModalProps> = ({
  isOpen,
  onClose,
  onSave,
  feeId,
  paymentMethods,
  amountNotPaid
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const maxSizeMB = process.env.REACT_APP_MAX_FILE_SIZE_MB;


  const handleSave = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      const formData = new FormData();
      Object.entries(values).forEach(([key, value]) => {
        if (key !== "transferProof" && value !== undefined && value !== null) {
          formData.append(key, String(value));

        }
      });
      if (values.transferProof) {
        formData.append("transferProof", values.transferProof);
      }
      formData.append("feeId", feeId);
      formData.append("status", "completed");
      console.log("formData",formData)
      await onSave(formData);
      onClose();
    } catch (error) {
      console.error("Error saving payment:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      form.resetFields();
      form.setFieldValue("amount", Number(amountNotPaid));
    }
  }, [isOpen]);

  return (
    <CustomModal
      title={t("add_fee_payment")}
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      loading={loading}
      saveText={t("add")}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t("amount")}
          name="amount"
          rules={[
            { required: true, message: t("validation.please_enter_amount") },
            {
              validator: (_, value) => {
                if (value > amountNotPaid) {
                  return Promise.reject(new Error(t("validation.amount_not_paid")));
                }
                return Promise.resolve();
              }
            },
          ]}
        >
          <InputNumber
            className="w-100"
            placeholder={t("amount")}
            min={0}
            precision={2}
            addonAfter="MAD"
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
          />
        </Form.Item>

        <Form.Item
          label={t("payment_method")}
          name="paymentMethodId"
          rules={[
            {
              required: true,
              message: t("validation.please_select_payment_method"),
            },
          ]}
        >
          <Select placeholder={t("select_payment_method")}>
            {paymentMethods.map((method) => (
              <Select.Option key={method.id} value={method.id}>
                {getLabelPaymentMethodByType(method.type)}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>


        <PaymentMethodExtraFields
          form={form}
          paymentMethods={paymentMethods}
          paymentMethodIdField="paymentMethodId"
          i18nBase="paymentMethod"
          accept=".pdf,.jpg,.jpeg,.png"
          maxCount={1}
          maxSizeMB={maxSizeMB}
          hasExistingTransferProof={false}

        />

        {/* <Form.Item
          label={t("status")}
          name="status"
          rules={[
            { required: true, message: t("validation.please_select_status") },
          ]}
        >
          <Select placeholder={t("select_status")}>
            <Select.Option value="completed">{t("completed")}</Select.Option>
            <Select.Option value="pending">{t("pending")}</Select.Option>
          </Select>
        </Form.Item> */}
      </Form>
    </CustomModal>
  );
};

export default AddFeePaymentModal;
